var map = {
	"./geology-earth.png": "1754",
	"./geology-jupiter.png": "85e7",
	"./geology-mars.png": "7708",
	"./geology-mercury.png": "4697",
	"./geology-neptune.png": "5aba",
	"./geology-saturn.png": "4831",
	"./geology-uranus.png": "5338",
	"./geology-venus.png": "1821"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f9b";